import React from "react";

// Mui
import Fade from "@mui/material/Fade";

// Mui Styles
import { StyledPaper } from "@/styles/mui/globalStyles";
// Navigate

// Components
import DataTable from "@/components/dataTable";
import Layout from "@/components/layout";
import Title from "@/components/title";

// Fetch
import {
  compareSales,
  compareSalesByShop,
  getProducts as getStatisticsProduct,
} from "@/fetch/fetchStatistics";

// Moment
import moment from "moment";
import "moment/locale/zh-hk";
// Config
import { compareDataTableColumn } from "@/config/tableColumnConfig";
import extractManningsData from "@/lib/extractManningsData";
import extractManningsMonthlyData from "@/lib/extractManningsMonthlyData";

// import extractHistoryManningsData from "@/lib/extractHistoryManningsData";
import CompareSalesFooter from "@/components/DataTable/compareSalesFooter";
import CompareSalesToolBar from "@/components/DataTable/compareSalesToolBar";

import { setFilter } from "@/features/dataTableSlice";
import { importProductSales, importShopSales } from "@/fetch/fetchMannings";
import { getProducts } from "@/fetch/fetchProduct";
import { getAllWorkLocation } from "@/fetch/fetchWork";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

import _ from "lodash";
const CompareSalesPage = (props) => {
  const { open, setOpen } = props;
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  // Navigate
  const [dataTableLoading, setDataTableLoading] = React.useState(false);
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [snackSeverity, setSnackSeverity] = React.useState("success");
  const [snackMessage, setSnackMessage] = React.useState("");
  const [column, setColumn] = React.useState([]);
  const [compareData, setCompareData] = React.useState([]);
  const [productData, setProductData] = React.useState([]);
  const selectedMode = useSelector((state) => state.dataTable.selectedMode);
  const selectedSource = useSelector((state) => state.dataTable.selectedSource);

  const dataTable = useSelector((state) => state.dataTable);

  const isCompare = Boolean(
    dataTable.dateFilter.startDate2 && dataTable.dateFilter.endDate2
  );

  const handleImportShop = async (e) => {
    try {
      setSnackOpen(true);
      setSnackSeverity("info");
      setSnackMessage("上載中.....");
      let productData = {};
      let locationData = {};
      const { data } = await getProducts();
      const { data: locations } = await getAllWorkLocation();
      _.forEach(locations, (location) => {
        locationData[location.work_shortcode] = location.id;
      });
      _.forEach(data, (d) => {
        productData[_.padStart(d.mannings_product_code, 6, "0")] = {
          m18_product_code: _.padStart(d.m18_product_code, 6, "0"),
          product_id: d.id,
        };
      });
      let insertedrecord = 0;
      let updatedRecord = 0;
      let allRow = 0;
      for (let i = 0; i < e.target.files.length; i++) {
        const datas = await extractManningsMonthlyData(
          e.target.files[i],
          productData,
          locationData
        );
        const { data: imported } = await importShopSales(datas);
        insertedrecord += parseInt(imported.ins);
        updatedRecord += parseInt(imported.upd);
        allRow += parseInt(imported.all_rows);
      }

      setSnackSeverity("success");
      setSnackMessage(
        `上載成功,\n新增了${insertedrecord}條紀錄\n更新了${updatedRecord}條紀錄\n共${allRow}條紀錄`
      );
    } catch (error) {
      setSnackSeverity("error");
      if (error.message === "productNotExist") {
        setSnackMessage(`上載失敗\n以下產品不存在\n${error.id}`);
      } else {
        setSnackMessage(`上載失敗`);
      }
      console.log(error);
    } finally {
    }
  };
  const handleImportProduct = async (e) => {
    try {
      setSnackOpen(true);
      setSnackSeverity("info");
      setSnackMessage("上載中.....");
      let productData = {};

      const { data } = await getProducts();
      // const { data: locations } = await getAllWorkLocation();

      _.forEach(data, (d) => {
        productData[_.padStart(d.mannings_product_code, 6, "0")] = {
          m18_product_code: _.padStart(d.m18_product_code, 6, "0"),
          product_id: d.id,
        };
      });
      const datas = await extractManningsData(e, productData);
      const { data: imported } = await importProductSales(datas);
      setSnackSeverity("success");
      setSnackMessage(
        `上載成功,\n新增了${imported.ins}條紀錄\n更新了${imported.upd}條紀錄\n共${imported.all_rows}條紀錄`
      );
    } catch (error) {
      setSnackSeverity("error");

      if (error.message === "productNotExist") {
        const message = [];
        for (const notFound in error.notFounds) {
          message.push(
            `${error.notFounds[notFound].mannings_product_code} - ${error.notFounds[notFound].product_name}`
          );
        }
        setSnackMessage(`上載失敗\n以下產品不存在\n${message.join("\n")}`);
      } else {
        setSnackMessage(`上載失敗`);
      }
      console.log(error);
    } finally {
    }
  };
  const getRowId = (row) => {
    const id = row.index;
    return id;
  };

  const fetchData = async (
    brand_id = [],
    product_master_id = [],
    dateRanges,
    dateGrouping,
    typeGrouping,
    combineSameSku,
    areaGrouping,
    selectedSource
  ) => {
    try {
      const isCompare = Boolean(dateRanges[1][0] && dateRanges[1][1]);
      setDataTableLoading(true);
      switch (typeGrouping) {
        case "shop":
          const { data: shopData } = await compareSalesByShop(
            brand_id,
            product_master_id,
            dateRanges,
            dateGrouping,
            areaGrouping,
            combineSameSku,
            selectedSource
          );

          setColumn(
            compareDataTableColumn(
              dateRanges,
              typeGrouping,
              dateGrouping,
              isCompare,
              shopData
            )
          );
          setCompareData(shopData);
          break;

        default:
          const { data } = await compareSales(
            brand_id,
            product_master_id,
            dateRanges,
            dateGrouping,
            typeGrouping,
            combineSameSku,
            selectedSource
          );

          setCompareData(data);
          setColumn(
            compareDataTableColumn(
              dateRanges,
              typeGrouping,
              dateGrouping,
              isCompare,
              data
            )
          );
          break;
      }
    } catch (err) {
      setSnackSeverity("error");
      setSnackMessage(
        `發生錯誤 \n ${err.message} \n Message:${err.response.data.message}`
      );

      setSnackOpen(true);
    } finally {
      setDataTableLoading(false);
    }
  };
  const fetchProduct = async () => {
    const { data } = await getStatisticsProduct();
    setProductData(data);
  };
  React.useEffect(() => {
    fetchProduct();
    if (searchParams.get("isShare")) {
      const params = {
        dateGrouping: searchParams.get("dateGrouping"),
        dateFilter: JSON.parse(searchParams.get("dateFilter")),
        selectedProduct: searchParams
          .get("selectedProduct")
          .split(",")
          .map((p) => parseInt(p)),
        typeGrouping: searchParams.get("typeGrouping"),
        combineSameSku: searchParams.get("combineSameSku"),
        selectedSource: searchParams.get("selectedSource").split(","),
        compareOption: searchParams.get("compareOption"),
        areaGrouping: searchParams.get("areaGrouping"),
      };
      dispatch(setFilter(params));
      fetchData(
        [],
        params.selectedProduct,
        [
          [
            moment(params.dateFilter.startDate1).format("YYYY-MM-DD"),
            moment(params.dateFilter.endDate1).format("YYYY-MM-DD"),
          ],
          [
            params.dateFilter.startDate2
              ? moment(params.dateFilter.startDate2).format("YYYY-MM-DD")
              : null,
            params.dateFilter.endDate2
              ? moment(params.dateFilter.endDate2).format("YYYY-MM-DD")
              : null,
          ],
        ],
        params.dateGrouping,
        params.typeGrouping,
        params.combineSameSku,
        params.areaGrouping,
        params.selectedSource
      );
      setSearchParams();
    }
  }, []);
  moment.updateLocale("zh-hk", {
    weekdaysShort: ["日", "一", "二", "三", "四", "五", "六"],
  });
  return (
    <Layout
      header="CompareSalesPage"
      selectedIndex={3}
      open={open}
      snackClose={() => setSnackOpen(false)}
      setOpen={setOpen}
      snackOpen={snackOpen}
      snackMessage={snackMessage}
      snackSeverity={snackSeverity}
    >
      <Title title="Sales comparison" />
      <Fade in={true} mountOnEnter unmountOnExit>
        <StyledPaper page={"yes"}>
          <DataTable
            loading={dataTableLoading}
            rows={compareData}
            Toolbar={CompareSalesToolBar}
            Footer={CompareSalesFooter}
            productData={productData}
            columns={column}
            handleImportProduct={handleImportProduct}
            handleImportShop={handleImportShop}
            noRowsLabel={"選擇篩選條件"}
            productSelecter={true}
            disableColumnSelector={false}
            disableColumnFilter={false}
            checkboxSelection={false}
            pinFirstColumn={false}
            searchBarPlaceholder={"搜尋產品"}
            pageSize={100}
            getRowId={getRowId}
            fetchData={fetchData}
          />
        </StyledPaper>
      </Fade>
    </Layout>
  );
};

export default CompareSalesPage;
